import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { logout } from "../../redux/actions/userAuthActions";
import { ReactComponent as BackOffice } from "../../components/assets/backOffice.svg";
import { ReactComponent as CatalogueIcon } from "../../components/assets/catalogue.svg";
import { ReactComponent as Crawlers } from "../../components/assets/crawler.svg";
import { ReactComponent as EnregistreIcon } from "../../components/assets/enregistres.svg";
import { ReactComponent as ImmoIcon } from "../../components/assets/immo.svg";
import "./sidebar.css";

const links = [
  {
    to: "/immobilier",
    icon: <ImmoIcon />,
    label: "Immobilier",
    roles: ["Collaborateur", "Administrateur"],
  },
  // {
  //   to: "/activite",
  //   icon: <ActiviteIcon />,
  //   label: "Activité",
  //   roles: ["Collaborateur", "Administrateur"],
  // },
  {
    to: "/catalogue",
    icon: <CatalogueIcon />,
    label: "Catalogue",
    roles: ["Collaborateur", "Administrateur"],
  },
  {
    to: "/backoffice",
    icon: <BackOffice />,
    label: "Back office",
    roles: ["Administrateur"],
  },
  {
    to: "/enregistres",
    icon: <EnregistreIcon />,
    label: "Enregistrés",
    roles: ["Collaborateur", "Administrateur"],
  },
  {
    to: "/crawlers",
    icon: <Crawlers />,
    label: "Crawlers",
    roles: ["Administrateur"],
  },
];

const Sidebar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { role, userLoading } = useSelector((state) => state.userAuthReducer);

  if (userLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        {/*  <div className="spinner-border text-primary" role="status"></div> */}
      </div>
    );
  }

  const filteredLinks = links.filter((link) => link.roles.includes(role));

  return (
    <div
      className="sidebar bg-white softerGrey d-flex flex-column"
      style={{ zIndex: 1000 }}
    >
      <div className="py-5 d-flex justify-content-center">
        <a href="/immobilier">
          <img
            src="./icons/logo_novanea1.svg"
            alt="main_logo"
            height={45}
            width={201}
            className="mx-auto logoLarge"
          />
          <img
            src="./logo_small.png"
            alt="main_logo"
            height={40}
            width={40}
            className="mx-auto logoSmall"
          />
        </a>
      </div>
      <nav>
        <ul className="p-0 m-0 d-flex flex-column gap40">
          {filteredLinks.map((link) => (
            <li key={link.to} className="">
              <NavLink
                to={link.to}
                className={({ isActive }) =>
                  isActive
                    ? "activeLink d-flex align-items-center ps-4"
                    : "inactiveLink d-flex align-items-center ps-4"
                }
              >
                {link.icon} <span className="labelMenu"> {link.label}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
      <div
        className="mt-auto d-flex gap10 align-items-center btnEffect mb-3"
        onClick={() => {
          dispatch(logout(navigate));
        }}
      >
        <img src="./icons/logout.svg" alt="logout" height={25} width={25} />
        <p className="fs10 text-softerGrey">Se déconnecter</p>
      </div>
    </div>
  );
};

export default Sidebar;
